import React from 'react';
import { AuthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import Export from './export/Export';
import Import from './import/Import';
import NavbarMenu from '../navbar/NavbarMenu';
import { useSelector } from 'react-redux';
import { getIsAccessDenied, USER_STATE_KEY } from '../../store/user/user-reducer';
import { StyledHeader, StyledProfile } from '@med-fe/ui';
import ProfilePanel from './profile-panel/ProfilePanel';
import styles from './header.module.scss';
import { useLocation } from 'react-router-dom';

export default function Header({ routes }) {
  const { pathname } = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const isAccessDenied = useSelector(getIsAccessDenied);
  const userRoles = useSelector((state: any) => state[USER_STATE_KEY]?.roles || []);
  const canAccessTemplate = userRoles.includes('MOD_ImportExport');

  const profilePanel = ({ accounts, onSignHandler }) => <ProfilePanel user={accounts[0]} onSignOut={onSignHandler} />;

  return (
    <StyledHeader isAuthenticated={isAuthenticated} style={{ position: 'relative', padding: 0 }}>
      <div className={styles.headerFlexRow}>
        <div className={styles.headerLeft}>
          <AuthenticatedTemplate>{!isAccessDenied && <NavbarMenu routes={routes} />}</AuthenticatedTemplate>
        </div>
        <div className={styles.headerRight}>
          <AuthenticatedTemplate>
            {!isAccessDenied && (
              <>
                {!pathname.includes('offices') &&
                  !pathname.includes('audit') &&
                  !pathname.includes('dashboard') &&
                  !pathname.includes('vendor') &&
                  !pathname.includes('import') &&
                  !pathname.includes('hoo-accommodations') &&
                  !pathname.includes('user-role-configuration') &&
                  !pathname.includes('holiday-schedule') &&
                  canAccessTemplate && <Import />}

                {!pathname.includes('dashboard') &&
                  !pathname.includes('import') &&
                  !pathname.includes('hoo-accommodations') &&
                  !pathname.includes('user-role-configuration') && <Export isTemplateAccessible={canAccessTemplate} />}
              </>
            )}
          </AuthenticatedTemplate>
          {isAuthenticated && <StyledProfile profilePanel={profilePanel} />}
        </div>
        <div className={styles.headerTitle}>
          <span className={styles.headerTitle__my}>My</span>
          <span className={styles.headerTitle__office}>Office</span>
          <span className={styles.headerTitle__directory}>Directory</span>
        </div>
      </div>
    </StyledHeader>
  );
}
